<template>
  <div>
    <div :class="classes" class="form-group form-group-default form-multiselect form-treeselect">
      <label>{{ label }}</label>
      <div v-if="hasRealHubs">
        <input type="hidden"
               v-model="internalValue"
               v-validate="validationRules"
               :data-vv-as="label"
               :id="fieldName"
               :name="fieldName" />

        <treeselect :options="servicesOptionsGrouped"
                    :multiple="false"
                    valueConsistsOf="LEAF_PRIORITY"
                    valueFormat="object"
                    :disableBranchNodes="true"
                    :placeholder="$t('multiselect.placeholder')"
                    v-model="internalValue"
                    :required="true"
                    :disabled="disabled"
                    :alwaysOpen="false"
                    @input="onChange">
          <template slot="value-label" slot-scope="{ node }">
            <services-with-hub :hub="hubFor(node.id)" :servicesNames="node.label" />
          </template>

          <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }">
            <span :class="{ bold: node.isBranch, 'text-black': node.isBranch }"> {{ node.label }} </span>
          </label>
        </treeselect>
      </div>

      <multiselect v-else
                   :id="id"
                   :allow-empty="false"
                   :options="servicesOptions"
                   :placeholder="$t('multiselect.placeholder')"
                   :showLabels="false"
                   label="name"
                   track-by="id"
                   @select="onChange"
                   v-model="internalValue"
                   :disabled="disabled"
                   :data-vv-as="label"
                   :data-vv-name="fieldName"
                   v-validate="validationRules">

        <span slot="noResult"> {{ $t("multiselect.no_result") }} </span>
      </multiselect>
    </div>

    <transition name="slide-fade">
      <label class="error" :for="id" v-show="errors.has(fieldName)">
        {{ errors.first(fieldName) }}
      </label>
    </transition>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ie_mixin from '@/mixin/ie'
import _ from 'lodash'
import Treeselect from '@riophae/vue-treeselect'
import ServicesWithHub from '@/components/hubs/ServicesWithHub'

export default {
  name: 'AffiliatedServiceField',
  props: {
    id: String,
    value: Object,
    label: String,
    required: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    options: { type: Array, default: null },
    fieldNameAddition: { type: [String, Number], default: null },
    hasRealHubs: { type: Boolean, default: false },
    availableHubs: { type: Array, default: () => [] },
  },
  components: {
    ServicesWithHub,
    Treeselect
  },
  mixins: [ie_mixin],
  inject: ['$validator'],
  data() {
    return {
      internalValue: null,
      treeSelectValue: null,
    }
  },
  mounted() {
    this.internalValue = this.value
  },
  watch: {
    value() {
      this.internalValue = this.value
    }
  },
  methods: {
    onChange(value) {
      this.$emit('change', value)
    },
    hubFor(service_id) {
      if(this.availableHubs === undefined) {
        return
      }

      var service = this.options.find((service) => service.id == service_id)
      if(!service) {
        return
      }

      return this.availableHubs.find((hub) => hub.id == service.hub_id)
    },
    hubNameFor(service_id) {
      if(this.availableHubs === undefined) {
        return
      }

      var service = this.options.find((service) => service.id == service_id)
      if(!service) {
        return
      }

      var hub = this.availableHubs.find((hub) => hub.id == service.hub_id)
      if(!hub) {
        return
      }

      return hub.name
    }
  },
  computed: {
    ...mapGetters({
      allServices: 'users/allServices',
      manageableServices: 'users/manageableServices'
    }),
    classes() {
      return {
        'required': this.required,
        'form-group-ie': this.isIE
      }
    },
    validationRules() {
      return this.required ? 'required' : false
    },
    servicesOptions() {
      return this.options || this.allServices || this.manageableServices
    },
    servicesOptionsGrouped() {
      var groupedServices = []
      var groupedServicesHash = _.groupBy(this.options, 'hub_id')

      Object.keys(groupedServicesHash).forEach((hub_id) => {
        var hub = this.availableHubs.find((hub) => hub.id == hub_id)

        if(hub) {
          groupedServices.push({
            label: hub.name,
            id: "hub_" + hub_id,
            hub_id: hub_id,
            isDefaultExpanded: groupedServicesHash[hub_id].find((service) => {
              return this.internalValue && service.id == this.internalValue.id
            }) !== undefined,
            children: groupedServicesHash[hub_id].map((service) => {
              return Object.assign({ label: service.name }, service)
            })
          })
        }
      })

      return groupedServices
    },
    fieldName() {
      return this.fieldNameAddition ? `affiliated_service_${this.fieldNameAddition}` : 'affiliated_service';
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '../../../assets/scss/pages/_var.scss';

  .icon-right {
    font-weight: bold;
    color: $color-pink;
  }

  .form-treeselect{
    overflow: visible;
  }

  .form-group-ie.form-treeselect .vue-treeselect{
    max-width: 450px;
  }

</style>



// WEBPACK FOOTER //
// src/components/users/form/AffiliatedServiceField.vue